import { KalDialogConfig, KalDialogRef, KalDialogService } from '@kalidea/kaligraphi';
import { Editor } from 'tinymce';
import {
    DocumentBankListDialogComponent,
    DocumentBankListDialogData
} from 'src/app/_shared/dialogs/document-bank-dialog/document-bank-list-dialog/document-bank-list-dialog.component';
import { filter, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { NgZone } from '@angular/core';

export class SharedEditorGedSelectionButton {

    private subscription: Subscription = Subscription.EMPTY;

    constructor(private readonly editor: Editor,
                private readonly ngZone: NgZone,
                private readonly dialogService: KalDialogService) {
        this.registerButton();
    }

    private registerButton(): void {
        this.editor.ui.registry.addIcon('ged', `
            <!--Google Material Icon : Create New Folder -->
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"/>
            </svg>
        `);

        this.editor.ui.registry.addButton('gedselection', {
            icon: 'ged',
            tooltip: 'Sélectionner un document dans la bibliothèque',
            onAction: () => {
                this.ngZone.run(() => {
                    this.subscription.unsubscribe();

                    const config = new KalDialogConfig<DocumentBankListDialogData>({
                        title: 'Sélectionner un document',
                        hasBackdrop: true,
                        backdropClass: 'cdk-overlay-dark-backdrop'
                    });

                    const dialogRef: KalDialogRef<DocumentBankListDialogComponent> = this.dialogService.open(DocumentBankListDialogComponent, config);

                    this.subscription = dialogRef.afterClosed.pipe(
                        filter(dialogResult => !!dialogResult?.accepted),
                        tap(({selectedDocument}) => this.editor.insertContent(`<a href="${selectedDocument.Url}" target="_blank"/>${selectedDocument.LibelleLien}</a>`))
                    ).subscribe();
                });
            }
        });
    }

}
